import request from '@/utils/request'

export function gradeList(query) {
  return request({
    url: '/api/group/listGrade',
    method: 'post',
    params: query
  })
}

export function createGrade(data) {
  return request({
    url: '/api/group/addGrade',
    method: 'post',
    data
  })
}

export function updateGrade(data) {
  return request({
    url: '/api/group/updateGrade',
    method: 'post',
    data
  })
}
